

	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { CompanyIndex } from '@shared/models';
	import CompanyItem from './CompanyItem.vue';

	@Component({
		components: {
			CompanyItem,
		},
	})
	export default class CompanyBrowse extends BaseView {


		public list: CompanyIndex[] = [];

		/** Fires when this component is mounted */
		public async mounted() {
			this.setTitle('Companies - SkateLurker');
			await this.refresh();
		}

		public async refresh() {
			try {
				this.loading = true;
				this.list = await this.$api.companyService.index();
			} catch (err) {
				this.errorMessage = 'An error occurred while getting the results';
				this.errorHandler.handle(err, this.errorMessage);
			} finally {
				this.loading = false;
			}
		}


	}

